<template>
	<div class="PaymentMethodPixMobile w-100">
		<div class="row">
			<div class="col bx-resumo col-lg-8 offset-lg-2 px-lg-5">
				<div class="resumoPedido">
					<div class="order-details mr-2">
						<p class="fieldName">Nº do Pedido:</p>
						<p class="fieldName">Vencimento:</p>
						<p class="fieldName">Valor:</p>
					</div>
					
					<div class="order-details ml-2">
						<div class="text-truncate fieldValue">{{boleto.order}}</div>
						<div class="fieldValue notranslate">{{$helper.formatDate(boleto.data_vencimento)}}</div>
						<div class="fieldValue">R$ {{$helper.formatValue(boleto.valor)}}</div>
					</div>
				</div>
			</div>
		</div>
		<div class="row mb-4" v-if="pix.pix_img">
			<div class="col bx-resumo col-lg-8 offset-lg-2 px-lg-5">
				<ul class="resumo-pedido">
					<li class="pix-title">
						Pague com o </br><b>QR Code</b> abaixo:
					</li>
					<li class="px-3 py-2 text-center">
						<img :src="pix.pix_img">
					</li>
					<li class="copy">
						<button ref="button" aria-describedby="tooltip" class="copy-btn" @click="copyToClipboard(pix.pix_code)">
							<inline-svg :src="require('@/assets/img/pbi/pbi_copy_24.svg')" />
							<span>PIX COPIA E COLA</span>
						</button>
						<div ref="tooltip" class="tooltip hide_tooltip noprint" role="tooltip">
							Copiado! 
							<div ref="arrow" class="arrow"></div>
						</div>
					</li>
					<li class="pix-automatically text-center mt-4">
						<span>Seu pagamento será confirmado automaticamente.</span>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>

import InlineSvg from 'vue-inline-svg';
import {
	computePosition,
	flip,
	offset,
	arrow
} from "@floating-ui/dom";

export default {
	name: 'PaymentMethodPix',
	data(){
		return{
			payload: {},
			pix_img: '',
			pix_code: '',
			payment_id: '',
		}
	},

	components: {
		InlineSvg
	},

	mounted: function(){},

	computed: {
		boleto(){
			return this.$store.state.boleto.boleto;
		},

		pix(){
			return this.$store.state.boleto.pix;
		},
	},

	methods: {
		copyToClipboard(value){
			this.$helper.copyToClipboard(value);

			const tooltip = this.$refs.tooltip;
			tooltip.classList.remove('hide_tooltip');
			tooltip.classList.add('show_tooltip');

			this.renderTooltip();

			setTimeout(() => {
				tooltip.classList.remove('show_tooltip');
				tooltip.classList.add('hide_tooltip');
			}, 2000);
		},

		renderTooltip(){
			const button	= this.$refs.button;
			const tooltip	= this.$refs.tooltip;
			const arrowEl	= this.$refs.arrow;
		
			computePosition(button, tooltip, {
				placement: 'bottom',
				middleware: [offset(6), flip(), arrow({ element: arrowEl })],
			}).then(({x, y, placement, middlewareData}) => {
				Object.assign(tooltip.style, {
					left: `${x}px`,
					top: `${y}px`,
				});

				const {x: arrowX, y: arrowY} = middlewareData.arrow;

				const staticSide = {
					top: 'bottom',
					right: 'left',
					bottom: 'top',
					left: 'right',
				}[placement.split('-')[0]];

				Object.assign(arrowEl.style, {
					left: arrowX != null ? `${arrowX}px` : '',
					top: arrowY != null ? `${arrowY}px` : '',
					right: '',
					bottom: '',
					[staticSide]: '-8px',
				});
			});
		}
	},

	filters: {
		taxid_display: function(value) {
			let taxid = (value || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
			let returnValue = '';
			
			if (taxid.length > 11) {
				returnValue = taxid.replace(/([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})(\d{2})/g, "$1.$2.$3/$4-$5");
			} else {
				returnValue = taxid.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "$1.$2.$3-$4");
			}
			
			return returnValue;
		},
	},
}
</script>